/* global document */
import { gsap } from 'gsap';
import { Draggable } from 'Renderer/gsap/Draggable';
import { InertiaPlugin } from 'Renderer/gsap/InertiaPlugin';

const createSpriteSlider = (id, spriteSrc, pixelsPerIncrement = 25) => {
  gsap.registerPlugin(Draggable, InertiaPlugin);
  let multiplier = 0;
  let lastMultiplier = 0;
  const slider = document.getElementById(id).childNodes[0];
  const dummy = slider.childNodes[1];
  const image = slider.childNodes[0];
  const sprites = spriteSrc;
  const spriteCount = spriteSrc.length;

  image.style.backgroundImage = `url(${sprites[0]})`;

  const updateFrame = () => {
    const xPos = gsap.getProperty(dummy, 'x');
    if (xPos < 0) return;
    multiplier = (Math.floor(xPos / pixelsPerIncrement) + lastMultiplier) % spriteCount;
    if (!isNaN(multiplier)) {
      image.style.backgroundImage = `url(${sprites[multiplier]})`;
    }
  };
  Draggable.create(dummy, {
    type: 'x',
    trigger: slider,
    throwProps: true,
    edgeResistance: 0,
    cursor: 'ew-resize',
    inertia: true,
    onDrag: updateFrame,
    onThrowUpdate: updateFrame,
    onThrowComplete: () => {
      lastMultiplier = multiplier % spriteCount;
    },
  });
};

export default createSpriteSlider;



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/threeSixtyScript.js